<template>
    <div class="container">
        <ais-instant-search
            :search-client="searchClient"
            :index-name="indexName"
            :insights="true"
            :future="futureConfig"
        >
            <div class="search-panel">
                <div class="search-panel__results">
                    <div class="searchbox">
                        <ais-search-box>
                            <template v-slot="{ currentRefinement, isSearchStalled, refine }">
                                <input
                                    type="search"
                                    id="searchInputAlgolia"
                                    :value="currentRefinement"
                                    @input="handleSearchInput($event, refine)"
                                >
                                <span :hidden="!isSearchStalled">Loading...</span>
                            </template>
                        </ais-search-box>
                    </div>
                    <ais-refinement-list
                        attribute="recordType"
                        :sort-by="['name:asc']"
                    />
                    <div v-show="currentSearchText.length > 0">
                        <ais-infinite-hits class="search-panel__results__items">
                            <template v-slot:item="{ item }">
                                <a :href="item.url" class="search-panel__results__item">
                                    <template v-if="item.recordType">
                                        <div class="search-panel__results__item__header" :class="'record-type-'+ stringToKebabCase(item.recordType)">
                                            <div class="h3 search-panel__results__item__record-type">
                                                {{ item.recordType }}
                                            </div>
                                        </div>
                                    </template>
                                    <article>
                                        <h3 class="search-panel__results__item__title">
                                            <ais-highlight :hit="item" attribute="title" />
                                        </h3>
                                        <template v-if="item.disciplines">
                                            <p class="search-panel__results__item__pills">
                                                <span class="search-panel__results__item__pills__label">Disciplines:</span>
                                                <template v-for="discipline in item.disciplines">
                                                    <span class="search-panel__results__item__pill">{{ discipline }}</span>
                                                </template>

                                            </p>
                                        </template>
                                        <template v-if="item.teamDesignations">
                                            <p class="search-panel__results__item__pills">
                                                <span class="search-panel__results__item__pills__label">Team:</span>
                                                <template v-for="teamDesignation in item.teamDesignations">
                                                    <span class="search-panel__results__item__pill">{{ teamDesignation }}</span>
                                                </template>
                                            </p>
                                        </template>
                                        <template v-if="item.articleCategories">
                                            <p class="search-panel__results__item__pills">
                                                <span class="search-panel__results__item__pills__label">Categories:</span>
                                                <template v-for="articleCategory in item.articleCategories">
                                                    <span class="search-panel__results__item__pill">
                                                        {{ articleCategory }}
                                                    </span>
                                                </template>
                                            </p>
                                        </template>
                                        <template v-if="item.summary">
                                            <div class="search-panel__results__item__summary" v-html="truncate(item.summary, 150)" />
                                        </template>
                                    </article>
                                </a>
                            </template>
                        </ais-infinite-hits>
                    </div>

                </div>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { AisInstantSearch, AisSearchBox, AisHits, AisInfiniteHits, AisPagination, AisRefinementList, AisHighlight } from 'vue-instantsearch/vue3/es';
import 'instantsearch.css/themes/algolia-min.css';

let AlgoliaAppId = 'I562S56YCK';
let AlgoliaSearchApiKey = 'd70e1024b9c1c91085ecdf08b1c29f8b';

const searchClient = {
    ...algoliasearch (
        AlgoliaAppId,
        AlgoliaSearchApiKey
    ),
    search(requests) {
        if (requests.every(({ params }) => !params.query)) {
            return Promise.resolve({
                results: requests.map(() => ({
                    hits: [],
                    nbHits: 0,
                    nbPages: 0,
                    processingTimeMS: 0,
                    query: '',
                })),
            });
        }
        return algoliasearch(
            AlgoliaAppId,
            AlgoliaSearchApiKey
        ).search(requests);
    },
};

export default {
    props: {
        indexName: {
            type: String,
            required: true,
        },
    },
    components: {
        AisInstantSearch,
        AisSearchBox,
        AisHits,
        AisInfiniteHits,
        AisPagination,
        AisRefinementList,
        AisHighlight,
    },

	data() {
		return {
			searchClient: searchClient,
            futureConfig: {
                preserveSharedStateOnUnmount: true,
            },
            currentSearchText: '',
		};
	},
    methods: {
        stringToKebabCase(str) {
            if (!str) return '';

            return str
            .replace(/\s+/g, '-') // Replace spaces with dash
            .toLowerCase();        // Convert to lowercase
        },
        truncate(value, length) {
            if (value.length > length) {
                return value.substring(0, length) + "...";
            } else {
                return value;
            }
        },
        handleSearchInput(event, refine) {
            const value = event.currentTarget.value;
            this.currentSearchText = value;  // Store the current search text
            refine(value);  // Update Algolia search
        },
    },

    computed: {
    },
    watch: {
    },
    mounted() {
    },
};
</script>

<style lang="scss">
    $usac-red: #c90019;
    $usac-blue: #003d6e;
    $usac-gold: #C69214;
    $usac-gray: #4d4d4d;

    .search-panel__results__items {
        ol {
            @media (max-width: 800px) {
                flex-direction: column;
                padding-left: 1rem;

                .ais-Hits-item,
                .ais-InfiniteHits-item {
                    width: 100%;
                    min-height: 200px;
                    margin-left: 0;

                    .search-panel__results__item {
                        min-height: 200px;
                    }
                }
            }

            li {
                padding: 0;
            }
        }

        .search-panel__results__item {
            padding: 2.7rem 1rem 1rem;
            height: 100%;
            width: 100%;
            display: block;
            text-decoration: none;
            position: relative;

            &:hover {
                box-shadow: 0 2px 5px 0px $usac-blue;
            }

            .search-panel__results__item__header {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                padding: .5rem 1rem;
                background-color: $usac-blue;
                color: white;
                text-align: right;

                &.record-type-article {
                    background-color: $usac-blue;
                    color: white;
                }

                &.record-type-athlete-bio {
                    background-color: $usac-gold;
                    color: white;
                }

                &.record-type-national-championships {
                    background-color: $usac-red;
                    color: white;
                }

                &.record-type-pages {
                    background-color: $usac-red;
                    color: white;
                }

                &.record-type-resource {
                    background-color: $usac-gray;
                    color: white;
                }

                .search-panel__results__item__record-type {
                    font-size: 0.8rem;
                    font-weight: 600;
                    text-transform: uppercase;

                    &.h3 {
                        margin: 0;
                    }
                }
            }

            .search-panel__results__item__title {
                font-size: 1.35rem;
                font-weight: 800;
                line-height: 1;
            }

            .search-panel__results__item__summary {
                margin-top: 0.5rem;
                font-size: 0.8rem;
                font-weight: 400;

                p {
                    font-family: "ProximaNova", sans-serif;
                    font-weight: 400;
                    margin-bottom: 0;
                }
            }
            .search-panel__results__item__pills {
                margin: 0;

                .search-panel__results__item__pills__label {
                    font-weight: 600;
                    font-size: 0.80rem;
                    text-transform: uppercase;
                    margin-right: 0.5rem;
                }

                .search-panel__results__item__pill {
                    display: inline-block;
                    padding: 0.17rem 0.40rem;
                    background-color: $usac-red;
                    line-height: 1;
                    color: white;
                    border-radius: 5px;
                    font-size: 0.7rem;
                    font-weight: 600;
                    text-transform: uppercase;
                    margin-right: 0.5rem;
                }
            }
        }

        .ais-InfiniteHits-loadMore {
            display: block;
            margin: 1rem auto 2rem;
            padding: 0.8rem 1.5rem;
            background-color: $usac-blue;
            color: white;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 0.8rem;

            &.ais-InfiniteHits-loadMore--disabled {
                display: none;
            }
        }
    }

    .ais-RefinementList-list {
        display: flex;
        flex-wrap: wrap;
        margin-left: -10px;

        .ais-RefinementList-item {
            margin-left: 10px;
        }

        .ais-RefinementList-count {
            display: none;
        }
    }
</style>
